import React, { Component } from 'react';
import Category from './helpers/Category';

export default class Education extends Component {
  lgHeader = {
    id: 'lgHeader',
    src: require('./images/education/txt_lg_EducationInfo.png'),
    left: 0,
    width: 732,
    height: 35
  };
  smHeader = {
    id: 'smHeader',
    src: require('./images/education/txt_sm_EducationInfo.png'),
    width: 222,
    height: 222
  };
  cat1Buttons = [
    {
      id: 'orientationVideo',
      to: '/ftg/cvod_orientation',
      highlight: require('./images/education/txt_OrientationVideo_HL.png'),
      unhighlight: require('./images/education/txt_OrientationVideo_UH.png'),
      alt: 'Orientation Video'
    },
    {
      id: 'educationLibrary',
      to: '/education_library',
      highlight: require('./images/education/txt_EducationLibrary_HL.png'),
      unhighlight: require('./images/education/txt_EducationLibrary_UH.png'),
      alt: 'Education Library'
    },
    {
      id: 'medEd',
      to: '/medication_education',
      highlight: require('./images/education/txt_MedicationEducation_HL.png'),
      unhighlight: require('./images/education/txt_MedicationEducation_UH.png'),
      alt: 'Medication Education'
    },
    {
      id: 'discharge',
      to: '/discharge_checklist',
      highlight: require('./images/education/txt_DischargeChecklist_HL.png'),
      unhighlight: require('./images/education/txt_DischargeChecklist_UH.png'),
      alt: 'Discharge Checklist'
    },
    {
      id: 'patientVistorInfo',
      to: '/patient_guide',
      highlight: require('./images/education/txt_PatientVisitorInfo_HL.png'),
      unhighlight: require('./images/education/txt_PatientVisitorInfo_UH.png'),
      alt: 'Patient & Visitor Info'
    },
    {
      id: 'provideFeedback',
      to: '/feedback',
      highlight: require('./images/education/txt_ProvideFeedback_HL.png'),
      unhighlight: require('./images/education/txt_ProvideFeedback_UH.png'),
      alt: 'Provide Feedback'
    }
  ];

  render() {
    const currentHighlight = this.props.current === this.props.movingPos && this.props.current === -2;
    const shrinkMe = this.props.current === -2 && (this.props.movingPos === -3 || this.props.movingPos === -1);
    const growMe = (this.props.current === -1 || this.props.current === -3) && this.props.movingPos === -2;

    return (
      <Category
        largeHeader={this.lgHeader}
        smallHeader={this.smHeader}
        serviceLinks={this.cat1Buttons}
        shrinkGrow={this.props.shrinkGrow}
        hlState={this.props.hlState}
        movedir={this.props.movedir}
        currentHighlight={currentHighlight}
        shrinkMe={shrinkMe}
        growMe={growMe}
        disabled={this.props.disabled}
      />
    );
  }
}
